import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface TextFieldProps {
  field: string;
  defaultValue?: string;
  help?: string;
  required?: boolean;
  onSubmit: (value: unknown) => void;
}

export function TextField({ field: _field, defaultValue, help, required, onSubmit }: TextFieldProps): React.ReactElement {
  const { t } = useTranslation();
  const [value, setValue] = useState(defaultValue ?? '');

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (required && !value.trim()) return;
      onSubmit(value.trim());
    },
    [value, required, onSubmit],
  );

  return (
    <form className="sp-field sp-field-text" onSubmit={handleSubmit}>
      <input
        className="sp-field-input"
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t('fields.typeAnswer')}
        autoFocus
      />
      {help && <span className="sp-field-help">{help}</span>}
      <button className="sp-field-submit" type="submit" disabled={required && !value.trim()}>
        {t('fields.submit')}
      </button>
    </form>
  );
}
